

<template>
  <div class="ph-compare-page">
    <top-bar ref="topBarRef" @goBack="goBack" title="产品对比"></top-bar>
    <div class="product-list-wrapper">
      <ul class="product-list" :style="{
        paddingBottom: bottomBarHeight + 'px'
      }">
        <li v-for="(item, index) in compareProducts" :key="index" class="product-item">
          <div class="product-row">
            <el-checkbox v-model="item.selected" class="product-checkbox"></el-checkbox>
            <div class="product-image" @click="toggleProduct(item)">
              <img :src="item.compare_image" alt="">
            </div>
            <div class="product-info" @click="toggleProduct(item)">
              <div class="product-name">{{item.name}}</div>
              <div class="product-category">{{item.compare_category ? item.compare_category.cn_name : '-'}}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="bottom-bar" ref="bottomBarRef">
      <div class="delete-btn" @click="deleteSelected">
        删除
      </div>
      <div class="select-all-btn" @click="toggleSelectAll">
        <div class="select-all-btn-con">
          {{isAllSelected ? '取消全选' : '全选'}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import topBar from "./components/top-bar.vue";
import actionBar from "./components/action-bar.vue";

export default {
  components: {actionBar, topBar},
  data() {
    return {
      listHeight: 0,
      bottomBarHeight: 0,
    };
  },
  computed: {
    ...mapState(['compare']),
    compareProducts() {
      return this.compare.products || []
    },
    isAllSelected() {
      if (this.compareProducts.length === 0) return false
      return this.compareProducts.every(item => item.selected)
    }
  },
  mounted() {
    const _this = this
    this.$nextTick(() => {
      _this.bottomBarHeight = _this.$refs.bottomBarRef.offsetHeight
      _this.listHeight = window.innerHeight - _this.$refs.topBarRef.$el.offsetHeight - 1.2

      _this.compareProducts.forEach(item => {
        _this.$set(item, 'selected', false)
      })
    })
  },
  methods: {
    toggleProduct(item){
      item.selected = !item.selected
    },
    goBack() {
      this.$router.back();
    },
    showAddProduct() {
      this.$router.push('/ph/compare/product-list')
    },
    showSearch() {
      console.log('搜索')
    },
    deleteSelected() {
      const selectedProducts = this.compareProducts.filter(item => item.selected)

      if (selectedProducts.length === 0) {
        this.$message.warning('请选择要删除的产品')
        return
      }

      const saveProducts = this.compareProducts.filter(item => !item.selected)

      this.$store.commit('saveCompareProducts', saveProducts)


      // this.$confirm(`确定删除 ${selectedProducts.length} 个产品？`, '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   const newProducts = this.compareProducts.filter(item => !item.selected)
      //   this.$store.commit('setCompareProducts', newProducts)
      //   this.$message.success('删除成功')
      // }).catch(() => {
      // })
    },
    toggleSelectAll() {
      const isSelected = !this.isAllSelected
      this.compareProducts.forEach(item => {
        this.$set(item, 'selected', isSelected)
      })
    }
  },
}
</script>

<style scoped>
@import "../../style/compare.css";

.product-list-wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: #fff;
}

.product-list {
  list-style: none;
  padding: 0 .32rem;
  margin: 0;
}

.product-item {
  list-style: none;
  border-bottom: 1px solid #dcdcdc;
}

.product-row {
  display: flex;
  align-items: center;
  padding: 0.3rem 0;
}

.product-checkbox {
  margin-right: 0.24rem;
  flex-shrink: 0;
}

.product-image {
  width: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.24rem;
  flex-shrink: 0;
}

.product-image img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.product-info {
  flex: 1;
  min-width: 0;
}

.product-name {
  font-size: 0.32rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 0.12rem;
}

.product-category {
  font-size: 0.24rem;
  color: #666;
}

.divider {
  height: 1px;
  background: #e5e5e5;
  margin-left: 0.32rem;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  padding: 0.2rem 0.32rem;
  background: #fff;
  border-top: 1px solid #e5e5e5;
  z-index: 999;
}

.delete-btn {
  flex: 1;
  height: 0.75rem;
  background: #f0252d;
  color: #fff;
  font-size: 0.28rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.12rem;
  cursor: pointer;
  clip-path: polygon(0 0, 100% 0, 95.5% 100%, 0% 100%);
}

.delete-btn:active {
  opacity: 0.8;
}

.select-all-btn {
  width: 2rem;
  height: 0.8rem;
  color: #333;
  font-size: 0.28rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e0e0e0;
  border-left: none;
  border-radius: 0.12rem;
  cursor: pointer;
  clip-path: polygon(12% 0, 100% 0, 100% 100%, 0% 100%);
  margin-left: -0.1rem;
}

.select-all-btn-con {
  width: 1.97rem;
  height: .77rem;
  font-size: 0.28rem;
  background-color: #ffffff;
  border-radius: 0.12rem;
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(12% 0, 100% 0, 100% 100%, 0% 100%);
}

.select-all-btn:active {
  opacity: 0.8;
}
</style>

<style>
.product-list .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #f0252d !important;
  border-color: #f0252d !important;
}

.product-list .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #f0252d;
}

.product-list .el-checkbox__inner:hover {
  border-color: #f0252d !important;
}
</style>